var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 9v6H9V9zm3-3H6v12h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5h-3v3h3zM39 9v6h-6V9zm3-3H30v12h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 10.5h-3v3h3zM15 33v6H9v-6zm3-3H6v12h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 34.5h-3v3h3zM6 24h12v3H6zm18-12h3v3h-3zm0-3h3v3h-3zm0-3h3v3h-3zm-3 9h3v3h-3zm3 6h3v3h-3zm0 6h3v12h-3zm9 0h3v15h-3zm-15-6h3v3h-3zm3 3h3v3h-3zm0 9.75h3v3h-3zM33 21h3v3h-3zm-6 6h3v3h-3zm9-3h3v3h-3zm0 9h3v3h-3zm0 6h3v3h-3zm3-12h3v3h-3zm0 6h3v3h-3zm-9 3h3v3h-3z"
  })))));
};
export default SvgQr;